import { __assign, __read } from "tslib";
import { useCallback } from 'react';
import { useControlled } from '../../../../utils/hooks/useControlled';
export function useControlledRadiobuttonGroup(_a) {
    var valueProp = _a.value, defaultValueProp = _a.defaultValue, changeHandlerProp = _a.changeHandler, componentName = _a.componentName, nameAttribute = _a.nameAttribute;
    var _b = __read(useControlled({
        controlled: valueProp,
        default: defaultValueProp,
        name: componentName,
        state: 'value',
    }), 2), value = _b[0], setValue = _b[1];
    var changeHandler = useCallback(function (e) {
        var newValue = e.target.value;
        setValue(newValue);
        changeHandlerProp === null || changeHandlerProp === void 0 ? void 0 : changeHandlerProp({ value: newValue, name: nameAttribute });
    }, [changeHandlerProp, nameAttribute]);
    function isChecked(option) {
        return value === undefined ? false : option.value === value;
    }
    function getOptionProps(option) {
        var checked = isChecked(option);
        return __assign(__assign({}, option), { checked: checked, name: nameAttribute, onChange: changeHandler });
    }
    return {
        value: value,
        changeHandler: changeHandler,
        isChecked: isChecked,
        getOptionProps: getOptionProps,
    };
}
//# sourceMappingURL=useControlledRadiobuttonGroup.js.map